import { createApp } from "vue";
import AppConfig from "@LandingPage/Scripts/Config/AppConfig";
import { router } from "@LandingPage/Scripts/Config/RouteConfig";
import { store } from "@LandingPage/Scripts/Config/StoreConfig";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["CookieToast", "LandingPage"]
        });

        this.initRequestVerificationToken();

        const app = createApp({});
        (<any>app).config.devtools = false;

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            app.use(DataWeb.default);
            app.use(DataWebConfig);

            DataWeb.default.registerRoutes(router);
            DataWeb.default.registerStoreModules(store);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        app.use(router).use(store).use(AppConfig);

        (<any>window).App.instances.vm = app.mount('#app');

        this.setNavigation();
    }

    private static initRequestVerificationToken() {
        const antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setNavigation() {
        let header = document.getElementById("Header")

        window.addEventListener("scroll", function () {
            if (window.scrollY > 0) {
                header.classList.add("minify");
            } else {
                header.classList.remove("minify");
            }
        });
    }
}